export default function(el, relative = false)
{
    let _x = 0;
    let _y = 0;

    while(el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop))
    {
        if(relative)
        {
            const style = window.getComputedStyle(el);

            if(style.getPropertyValue('position') === 'relative') break;
        }

        _x += el.offsetLeft;
        _y += el.offsetTop;
        el = el.offsetParent;
    }

    return {
        top: _y,
        left: _x,
    };
}
